module["exports"] = [
  "#{Address.city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/address/city.js
// module id = 161
// module chunks = 0